<template>

   <spinner v-if="!loaded" ></spinner>

    <div class="template-padding" v-else-if="loaded"  > 
        
        <!-- ACADEMY -->
        <div class="row" >
            <div class="col-12" >
                <b-input-group>
                    <b-form-input v-model="filter" placeholder="Search courses" class="search-input atlass-input-borderless" />
                    <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
                </b-input-group>
            </div>
        </div>
        
        <vue-good-table
            class="mt-5"
            :columns="columns"
            :rows="rows"
            styleClass="vgt-table atlass-datatable academy-table large"
            :search-options="{ enabled: true, externalQuery: filter }"
            :pagination-options="{ 
                enabled: false,
                perPage: 20,
                perPageDropdown: [50, 100],
                ropdownAllowAll: true,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Leads per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
            }"
            :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"
            @on-row-click="openRow"
             >
            
            <template slot="table-row" slot-scope="props">
                
                <span v-if="props.column.field == 'Name'">
                    <h4 class="font-weight-bold" > {{ props.row.Name }} </h4>
                    <p> {{ props.row.Description }} </p>
                </span>
                
                <span v-else-if="props.column.field == 'Icon'">
                    <span class="tablecell-icon" > <img :src="require(`@/assets/${props.row.Icon}.png`)" />  </span>
                </span>
                
                <span v-else-if="props.column.field == 'Status'">
                    <span v-if="props.row.Status == -1" > <font-awesome-icon :icon="['fa', 'cog']" /> Coming soon </span>
                    <span v-if="props.row.Status == 0" > <font-awesome-icon :icon="['fa', 'circle']" /> Unavailable </span>
                    <span v-if="props.row.Status == 1" > <font-awesome-icon :icon="['fa', 'check-circle']" class="color-green" /> Available  </span>
                </span>
                
                <span v-else  >
                  {{props.formattedRow[props.column.field]}}
                </span>
                
            </template>
            
        </vue-good-table>
        <!-- ACADEMY -->
        
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import jwt_decode from "jwt-decode";
import axios from 'axios'
    
export default{
    name: "Academy",
    props:["APPKEY"],
    components:{
    },
    data () {
        return {
            loaded: false,
            filter: '',
            columns: [
                {
                    label: '',
                    field: 'Icon',
                    sortable: false,
                    html: true,
                    width: '80px',
                    tdClass: 'icon-cell text-center',
                },
                {
                    label: 'NAME',
                    field: 'Name'
                },
                {
                    label: 'TYPE',
                    field: 'Type',
                    hidden: true,
                },
                {
                    label: 'STATUS',
                    field: 'Status'
                },
                {
                    label: 'CREATED',
                    field: 'datetime',
                    formatFn: this.returnDate,
                    tdClass: 'text-right',
                },
            ],
            rows: [
                {
                    "ID": '1',
                    "Type": "course",
                    "Label": "Offer",
                    "Icon": 'images/business_accelerator_1200x628-01',
                    "Name": "The Business Accelerator",
                    "Slug": "business-accelerator",
                    "Description": "Learn how to craft your perfect sales offer: story, avatar, unique selling point, product stack",
                    "Status": 1,

                },
                /*
                {
                    "ID": '1',
                    "Type": "course",
                    "Label": "Offer",
                    "Icon": 'images/craft_perfect_offer_title_1200x628-01',
                    "Name": "Craft the Perfect Sales Offer",
                    "Slug": "perfect-sales-offer",
                    "Description": "Learn how to craft your perfect sales offer: story, avatar, unique selling point, product stack",
                    "Status": 1,

                },
                {
                    "ID": '2',
                    "Type": "course",
                    "Label": "Funnel",
                    "Icon": 'images/craft_perfect_offer_title_1200x628-01',
                    "Name": "Craft the Perfect Funnel",
                    "Slug": "perfect-sales-funnel",
                    "Description": "Learn how to create your perfect funnel or turn your existing funnel into a high-converting machine",
                    "Status": 1,

                },
                */
                {
                    "ID": '2',
                    "Type": "course",
                    "Label": "Copywriting",
                    "Icon": 'images/copywriting_masterclass_1200x628-01',
                    "Name": "Copywriting Masterclass",
                    "Slug": "copywriting-masterclass",
                    "Description": "Learn how to write copy that actually sells",
                    "Status": 1,

                },
                {
                    "ID": '3',
                    "Type": "course",
                    "Label": "Ads",
                    "Icon": 'images/facebook_ads_masterclass_1200x628-01',
                    "Name": "Facebook Ads Masterclass",
                    "Slug": "facebook-ads-masterclass",
                    "Description": "Learn how to properly create and run Facebook ads for your business",
                    "Status": 1,

                },
                /*
                {
                    "ID": '4',
                    "Type": "course",
                    "Label": "Ads",
                    "Icon": 'images/google_ads_masterclass_1200x628-01',
                    "Name": "Google AdWords Ads Masterclass",
                    "Slug": "google-ads-masterclass",
                    "Description": "Learn how to properly create and run Google AdWords ads for your business",
                    "Status": -1,

                },
                */
            ]
        }
    },
    mounted(){
        this.loaded = true;
    },
    methods:{
        openRow(params){
            
            //let user =  Cookies.get('user')
            //user = JSON.parse( atob( user ) )
            
            let user = jwt_decode(Cookies.get('user-token'))
            console.log(user)
            
            let page = params.row.Icon;
            let ID = params.row.ID;
            
            //console.log(ID)
            //console.log(params.row.Name)
            if( ( params.row.Status < 0 && this.$store.getters.getRole == 0 ) || params.row.Status >= 0 || user.email.includes('theatlass.com') || user.test_account == true ){
                 this.$router.push({
                    //name: params.row.Name
                    path: "/academy/"+params.row.Slug
                });
            }
            
                
            
        },
        returnDate(a){
            //return this.$moment.unix(a).format( 'MMM D, HH:mm' )
            return helper.formatDate( a, 'MMM D, HH:mm' )
        },
    },
    computed: {

    },
    created: function () {

    },
    
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/templates/Academy/Academy.vue